export function toOrganizationCrisId(id) {
  return `ou${String(id).padStart(5, "0")}`;
}

export function toResearcherCrisId(id) {
  return `rp${String(id).padStart(5, "0")}`;
}
